/**
 * @fileoverview POST handler for the "/email/ip_warming/:app_group_id/delete/:plan_id" endpoint
 */
import fetch from "@lib/fetch";

import { createMutationFetcherFunctionWithShadowError } from "../reactQueryFetcherAdapters/createMutationFetcherFunctionWithShadowError";
import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { postEmailIpWarmingAppGroupIdDeleteCacheKeys } from "./constants";
import type {
  PostEmailIpWarmingAppGroupIdDeleteProps,
  PostEmailIpWarmingDeleteResult,
  PostEmailIpWarmingDeleteResultErrors,
} from "./types";

export const postEmailIpWarmingDelete = reactQueryMutationAdapter(
  postEmailIpWarmingAppGroupIdDeleteCacheKeys,
  createMutationFetcherFunctionWithShadowError<PostEmailIpWarmingDeleteResultErrors>()(
    (props: PostEmailIpWarmingAppGroupIdDeleteProps): Promise<PostEmailIpWarmingDeleteResult> => {
      const { appGroupId, planId } = props;

      return fetch(`/email/ip_warming/${appGroupId}/delete/${planId}`, "POST", {}, undefined, {
        propagateFetchRequestError: false,
      });
    }
  )
);
